import React, { forwardRef, useMemo } from 'react'
import './currency-textfield.css'

// COMPONENTS
import TextField from '@components/atoms/textfield'

// UTILITIES
import { priceFormatter, toPennies } from '@utils/number-helper'
import { flatten } from '@utils/string-helper'


interface Props extends Omit<React.ComponentProps<typeof TextField>, 'inputMode' | 'autoComplete' | 'type'> {
    centered?: boolean
    invalid?: boolean
}

const CurrencyTextField = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const { className: classProps, style: styleProps, centered = false, invalid, placeholder = '0', ...inputProps } = props
    const className = flatten("usd-currency textfield", { invalid }, classProps)
    const { max, min, value } = inputProps

    const overMax = useMemo(() => (!!max && toPennies(value as string) > (Number(max))), [value, max])
    const overMin = useMemo(() => (!!min && toPennies(value as string) < (Number(min))), [value, min])

    return (
        <label className={flatten(className, (overMax || overMin ? "over" : ""))} style={styleProps}>
            <p className="text-body-2 select-none text-gray-500" style={{ fontSize: 'x-large', position: centered ? 'absolute' : 'relative' }}>$</p>
            <div className='flex flex-col justify-center items-end w-full'>
                <input ref={ref} {...inputProps} style={{ textAlign: centered ? 'center' : 'right' }} placeholder={placeholder} inputMode="decimal" type="text" autoComplete="off" />
                {(overMax || overMin) && <small className='select-none' style={{ color: 'var(--splitcard-red-500)', marginTop: '-0.5rem' }}>{overMax ? `max: ${priceFormatter.format(Number(max) / 100)}` : `min: ${priceFormatter.format(Number(min) / 100)}`}</small>}
            </div>
        </label>
    )
})

CurrencyTextField.displayName = 'CurrencyTextField'

export default CurrencyTextField
